import Flex from 'style-utils/components/Flex';
import SingleStep from './components/SingleStep';
import { WithFlexboxProps } from 'style-utils/withStyledProps/withFlexboxProps';

type StepperProps = WithFlexboxProps & {
  activeStep?: number;
  numberOfSteps?: number;
};

const Stepper = (props: StepperProps) => {
  const {
    activeStep = 1,
    numberOfSteps = 3,
    w = '100%',
    justifyContent = 'center',
    m = '2rem 0 0',
    ...restOfFlexboxProps
  } = props;

  return (
    <Flex w={w} justifyContent={justifyContent} m={m} {...restOfFlexboxProps}>
      {Array(numberOfSteps)
        .fill('')
        .map((_, index) => {
          const step = index + 1;
          return (
            <SingleStep
              key={index}
              isCompleted={step <= activeStep}
              isActive={step === activeStep}
              step={step}
            />
          );
        })}
    </Flex>
  );
};

export default Stepper;
